import React, { FC } from 'react';
import './MiniPTAi.component.css';

// 🔹 Assets
import miniPTCare from 'url:../../assets/videos/mini-pt-care.mp4';

type MiniPtCardProps = {
  src?: string;
  title?: string;
  autoPlay?: boolean;
  loop?: boolean;
  muted?: boolean;
};

const MiniPTAi: FC<MiniPtCardProps> = ({
  src = miniPTCare,
  title = 'MiniPT Core',
  autoPlay = true,
  loop = true,
  muted = true,
}) => {
  return (
    <div className="miniPt">
      <video
        src={src}
        className="miniPtVideo"
        autoPlay={autoPlay}
        loop={loop}
        muted={muted}
        playsInline
      />
      <span className="miniPtVideoText">{title}</span>
    </div>
  );
};

export default MiniPTAi;
